import { render, staticRenderFns } from "./GlobalEmptyRecord.vue?vue&type=template&id=cc934856&scoped=true&"
import script from "./GlobalEmptyRecord.vue?vue&type=script&lang=js&"
export * from "./GlobalEmptyRecord.vue?vue&type=script&lang=js&"
import style0 from "./GlobalEmptyRecord.vue?vue&type=style&index=0&id=cc934856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc934856",
  null
  
)

export default component.exports